import React, { useEffect, useState, useCallback } from 'react';
import AddSalesPersonModal from './AddSalesPersonModal';
import ViewSalesPersonModal from './ViewSalesPersonModal';
import PaginationControls from '../Building/components/Renders/PaginationControls';
import SearchIcon from '@mui/icons-material/Search';
import API_BASE_URL from '../../../../Constants';
import { ColorRing } from 'react-loader-spinner';

const SalesPersonFields = [
    { key: 'actions', label: 'Actions' },
    { key: 'id', label: 'Sales ID' },
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'status', label: 'Status' },
];

const SalesPersonList = () => {
    const [salesPersons, setSalesPersons] = useState([]);
    const [filteredSalesPersons, setFilteredSalesPersons] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const handleOpenCreateModal = () => setIsCreateOpen(true);
    const handleCloseCreateModal = () => setIsCreateOpen(false);


    // const clearUserLocks = async (user) => {
    //     try {
    //         const response = await fetch(`${API_BASE_URL}/api/record/${encodeURIComponent(user)}/clear-locks`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             credentials: 'include',
    //         });

    //         if (response.ok) {
    //             const message = await response.text(); // Get the response message
    //             console.log('Server response:', message); // Logs the response from the server
    //             // notify all users that the record has been unlocked by post request
    //             // notify all the requesters for that particular record they requested is open
    //             notifyRequesters(selectedSalesPerson.id);


    //         } else {
    //             throw new Error('Failed to clear locks');
    //         }
    //     } catch (error) {
    //         console.error('An error occurred:', error.message);
    //     }
    // };



    // // API CALL TO NOTIFY REQUESTERS
    // const notifyRequesters = async (recordId) => {
    //     try {
    //         const response = await fetch(`${API_BASE_URL}/api/notify/requesters?recordId=${encodeURIComponent(recordId + "-salesperson")}`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             credentials: 'include',

    //         });

    //         if (response.ok) {
    //             const message = await response.text();
    //             console.log('Server response:', message);
    //         } else {
    //             throw new Error('Failed to notify requesters');
    //         }
    //     } catch (error) {
    //         console.error('An error occurred:', error.message);
    //     }
    // }




    const handleOpenViewModal = (salesPerson) => {
        setSelectedSalesPerson(salesPerson);
        setIsViewOpen(true);
    };
    const handleCloseViewModal = () => {

        setIsViewOpen(false)
    };

    const fetchSalesPersons = useCallback(async (page = currentPage, size = rowsPerPage, query = searchQuery) => {
        try {
            setIsLoading(true);
            const queryString = query ? `&q=${encodeURIComponent(query)}` : '';
            const response = await fetch(`${API_BASE_URL}/api/setup/salesperson/filtered-salespersons?page=${page - 1}&size=${size}${queryString}`, { credentials: 'include' });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setSalesPersons(Array.isArray(data.content) ? data.content : []);
            setFilteredSalesPersons(Array.isArray(data.content) ? data.content : []);
            setCurrentPage(data.number + 1);
            setTotalPages(data.totalPages);
            setIsLoading(false);
        } catch (error) {
            console.error('Fetch error: ', error);
            setSalesPersons([]);
            setFilteredSalesPersons([]);
            setIsLoading(false);
        }
    }, [currentPage, rowsPerPage]);



    const setNewComponentRight = () => {

        var currentIndex = 0;
        if (selectedSalesPerson) {

            currentIndex = filteredSalesPersons.indexOf(selectedSalesPerson) || 0;

        }
        setSelectedSalesPerson(filteredSalesPersons[(currentIndex + 1) % filteredSalesPersons.length]);
    }

    const setNewComponentLeft = () => {
        var currentIndex = 0;
        if (selectedSalesPerson) {

            currentIndex = filteredSalesPersons.indexOf(selectedSalesPerson) || 0;

        }
        setSelectedSalesPerson(filteredSalesPersons[(currentIndex - 1 + filteredSalesPersons.length) % filteredSalesPersons.length]);
    }


    useEffect(() => {
        fetchSalesPersons(currentPage, rowsPerPage, searchQuery);
    }, [fetchSalesPersons, currentPage, rowsPerPage]);

    const handlePageChange = (page) => setCurrentPage(page);

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        if (e.target.value === '' && isSearched) {
            fetchSalesPersons(1, rowsPerPage, "");
            setIsSearched(false);
        } else {
            const filtered = salesPersons.filter((salesPerson) =>
                salesPerson.firstName.toLowerCase().includes(e.target.value.toLowerCase()) ||
                salesPerson.lastName.toLowerCase().includes(e.target.value.toLowerCase()) ||
                salesPerson.phone1.includes(e.target.value)
            );
            setFilteredSalesPersons(filtered);
        }
    };

    const handleSearch = () => {
        setIsSearched(true);
        fetchSalesPersons(1, rowsPerPage, searchQuery);
    };

    return (
        <div className="mx-auto pl-4 pr-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Sales Person List</h2>
                <div className="flex justify-end gap-4">
                    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                        <div className="px-3 py-2 text-gray-500 cursor-pointer">
                            <SearchIcon onClick={handleSearch} />
                        </div>
                        <input
                            type="text"
                            className="px-3 py-2 w-full outline-none"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            readOnly={isLoading}
                        />
                    </div>
                    <button
                        className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold
                        hover:bg-yellow-500 transition duration-300 ease-in-out"
                        onClick={handleOpenCreateModal}
                    >
                        Add +
                    </button>
                </div>
            </div>

            <div className="flex justify-center items-center">
                <ColorRing
                    visible={isLoading}
                    height="200"
                    width="200"
                    ariaLabel="color-ring-loading"
                    colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
                />
            </div>

            {!isLoading ? (
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {SalesPersonFields.map((field) => (
                                <th
                                    key={field.key}
                                    className="px-4 py-2 text-left font-bold text-sss-blue-sel"
                                >
                                    {field.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {filteredSalesPersons.map((salesPerson) => {
                            return (
                                <tr key={salesPerson.id} className="border-t">
                                    {SalesPersonFields.map((field) => {

                                        if (field.key === 'actions') {
                                            return (
                                                <td key={field.key} className="px-4 py-2">
                                                    <div className="flex space-x-2">
                                                        <button
                                                            className="text-sss-info mr-2"
                                                            onClick={() => handleOpenViewModal(salesPerson)}
                                                        >
                                                            View
                                                        </button>
                                                    </div>
                                                </td>
                                            );
                                        }

                                        return (
                                            <td key={field.key} className="px-4 py-2">
                                                {salesPerson[field.key]}
                                            </td>
                                        )
                                    }


                                    )}
                                </tr>
                            )
                        }


                        )}
                    </tbody>
                </table>
            ) : null}

            <ViewSalesPersonModal
                open={isViewOpen}
                handleClose={handleCloseViewModal}
                salesPerson={selectedSalesPerson}
                setSalesPerson={setSelectedSalesPerson}
                setNext={setNewComponentRight}
                setPrev={setNewComponentLeft}

                allPersons={filteredSalesPersons}
                updateAll={setFilteredSalesPersons}
            />

            <AddSalesPersonModal
                open={isCreateOpen}
                handleClose={handleCloseCreateModal}
            />

            <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    );
};

export default SalesPersonList;
